import styled from "styled-components";

export const PhotoWrap = styled.div`
  position: relative;
  height: 200px;
  background: ${(p) => p.theme.tokens.colors.bg};
  flex-shrink: 0;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: none;
  background: rgba(255, 255, 255, 0.92);
  color: #41524d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
`;

export const Body = styled.div`
  overflow-y: auto;
  flex: 1;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Header = styled.div`
  padding: 16px 18px 8px;
`;

export const Name = styled.div`
  font-weight: 900;
  font-size: 21px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.4px;
`;

export const Description = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.tokens.colors.muted};
  line-height: 1.5;
  margin-top: 7px;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 12px;
`;

export const Price = styled.span`
  font-weight: 900;
  font-size: 19px;
  color: ${(p) => p.theme.tokens.colors.teal};
`;

export const OldPrice = styled.span`
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-decoration: line-through;
`;

export const ExtrasSection = styled.div`
  background: #fafbfb;
  margin-top: 8px;
`;

export const ExtrasBody = styled.div`
  padding: 12px 14px 16px;
`;

export const OptionsCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 16px;
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  padding: 4px 14px;
`;

export const ObsSection = styled.div`
  padding: 8px 18px 18px;
`;

export const ObsLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-weight: 800;
  font-size: 14px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const ObsHint = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  resize: none;
  border: 1.5px solid ${(p) => p.theme.tokens.colors.inputBorder};
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 14px;
  font-family: ${(p) => p.theme.tokens.font.family};
  color: ${(p) => p.theme.tokens.colors.ink};
  outline: none;
  background: ${(p) => p.theme.tokens.colors.inputBg};

  &:focus {
    border-color: ${(p) => p.theme.tokens.colors.green};
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 16px calc(0px + env(safe-area-inset-bottom));
  border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  align-items: center;
  flex-shrink: 0;
`;

export const AmountStepper = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  background: ${(p) => p.theme.tokens.colors.bg};
  border-radius: 14px;
  padding: 5px 10px;
`;

export const StepButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 13px;
  border: none;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const AmountValue = styled.span`
  min-width: 16px;
  text-align: center;
  font-weight: 800;
  font-size: 16px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const AddButton = styled.button`
  flex: 1;
  border: none;
  cursor: pointer;
  border-radius: 16px;
  padding: 16px 22px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: 16.5px;
  color: #fff;
  background: ${(p) => p.theme.tokens.gradients.accent};
  box-shadow: ${(p) => p.theme.tokens.shadows.ctaAccent};
`;
